import { cx } from '@emotion/css';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { OptionProps, components } from 'react-select';
import { PhoenixIcon } from '../../../phoenix-icon/phoenix-icon';
import { OptionPropsExtra } from '../dropdown';

export const DropdownOption = ({ children, onDeleteOption, ...props }: OptionPropsExtra) => {
  const isNew = (props?.data as any)?.__isNew__;
  const value = (props?.data as any)?.value;

  return (
    <components.Option
      className={cx(onDeleteOption && '!flex justify-between gap-x-4')}
      {...props}
      innerProps={{ ...props.innerProps, 'data-testid': 'dropdown-option' } as OptionProps['innerProps']}
    >
      <div className={cx(onDeleteOption && 'truncate')}>{children}</div>

      {onDeleteOption && !isNew && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onDeleteOption(value);
          }}
        >
          <PhoenixIcon className="h-3 w-3" icon={getDesignSystemIcon('icon-bin-16.svg')} />
        </button>
      )}
    </components.Option>
  );
};
